module.exports = "/static-assets/_next/static/images/wand-490c9a147f840a3eac89f12dfc858254.png";